export default __webpack_public_path__ + "static/media/ic_qatar.99300de6.svg";